import Slide from '@/mixins/Slide'
import List from '@/components/List'
import AnimatedNumber from '@/components/AnimatedNumber'

export default
{
    mixins: [
        Slide
    ],

    components: {
        List,
        AnimatedNumber
    },

    methods:
    {
        openPopin()
        {

        }
    }
}
